import { BreadCrumb } from "primereact/breadcrumb";

import { useBreadcrumbContextOptional } from "../../contexts/Breadcrumb/BreadcrumbProvider";
import { INTERNAL_ROUTES } from "../../../constants/routes";
import { useSmartNavigation } from "../../../helpers/navigation";

import S from "./PageBreadcrumb.module.scss";

/**
 * Renders breadcrumbs inline within the page content (below the navbar).
 * Only renders when the current breadcrumb display mode is "page".
 * Pages using `useBreadcrumb({ ..., display: "page" })` should include
 * this component as the first element in their render output.
 */
export function PageBreadcrumb() {
  const breadcrumbCtx = useBreadcrumbContextOptional();
  const { navigateTo } = useSmartNavigation();

  if (!breadcrumbCtx || breadcrumbCtx.display !== "page" || !breadcrumbCtx.breadcrumbs) {
    return null;
  }

  const defaultHome = {
    label: INTERNAL_ROUTES.Learn.name,
    command: () => navigateTo(INTERNAL_ROUTES.Learn.route),
  };

  return (
    <div className={S.pageBreadcrumb}>
      <BreadCrumb
        model={breadcrumbCtx.breadcrumbs}
        home={breadcrumbCtx.homeItem ?? defaultHome}
        pt={{
          root: { className: S.breadcrumbRoot, "aria-label": "Breadcrumb" },
          // WCAG fix: PrimeReact renders separators as <li role="separator"> inside <ol>,
          // which breaks list semantics. Override back to listitem.
          separator: { role: "listitem" },
        }}
      />
    </div>
  );
}
